import React from 'react';
import IndividualProjectCard from '../../components/IndividualProjectCard'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { Modal, Row } from 'antd';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

class IndividualProjects extends React.Component {
  state = {
    projectList: []
  }

  componentDidUpdate = (prevProps) => {

    if (prevProps.projects !== this.props.projects || prevProps.users !== this.props.users || prevProps.projectFilter !== this.props.projectFilter) {
      const { name, reaction, type, stage, submit } = this.props.projectFilter
      const { projects, users } = this.props
      let projectList = []
      if (projects && users) {
        for (let key in projects) {
          if (projects.hasOwnProperty(key)) {
            for (let insideKey in projects[key]) {
              if (projects[key].hasOwnProperty(insideKey)) {
                let currentProject = projects[key][insideKey]
                projectList.push({
                  'userId': key,
                  status: currentProject.status,
                  'projectId': insideKey,
                  projectDetails: currentProject,
                  'myp': users[key] && users[key].profile && users[key].profile.myp,
                  'studentName': (users[key] && users[key].profile) ? users[key].profile.name + ' ' + users[key].profile.last_name : ''
                })
              }
            }
          }
        }
      }


      if (submit) {
        if (name) {
          projectList = projectList.filter((i) => (i.studentName !== undefined && i.studentName.toLowerCase().indexOf(name.toLowerCase()) !== -1))
        }
        if (reaction) {
          projectList = projectList.filter((i) => (i.projectDetails && i.projectDetails.feeling === reaction))
        }
        if (type) {
          projectList = projectList.filter((i) => (i.projectDetails && i.projectDetails.Investigation && i.projectDetails.Investigation.projectType === type))
        }
        if (stage) {
          switch (stage) {
            case 'Investigation':
              projectList = projectList.filter((i) => (i.projectDetails && (i.projectDetails.status === 'complete' || (i.projectDetails.Investigation && i.projectDetails.Investigation.is_complete === true))))

            case 'Preparation':
              projectList = projectList.filter((i) => (i.projectDetails && (i.projectDetails.status === 'complete' || (i.projectDetails.Preparation && i.projectDetails.Preparation.is_complete === true))))

            case 'Actions':
              projectList = projectList.filter((i) => (i.projectDetails && (i.projectDetails.status === 'complete' || (i.projectDetails.Actions && i.projectDetails.Actions.is_complete === true))))

            case 'Demonstration':
              projectList = projectList.filter((i) => (i.projectDetails && (i.projectDetails.status === 'complete' || (i.projectDetails.Demonstration && i.projectDetails.Demonstration.is_complete === true))))

            case 'Reflection':
              projectList = projectList.filter((i) => (i.projectDetails && (i.projectDetails.status === 'complete' || (i.projectDetails.Reflection && i.projectDetails.Reflection.is_complete === true))))
          }
        }
      }
      this.setState({ projectList })
    }
  }


  render() {

    const { projectList } = this.state
    const { atl_category, learningOutcomes } = this.props

    return (

      <div>
        <Row className="serviceTracker" style={{ margin: '0px 10px' }}>
          {projectList.map((item) => {
            return (
              <IndividualProjectCard
                project={item.projectDetails}
                status={item.status}
                studentName={item.studentName}
                myp={item.myp}
                atl_category={atl_category}
                learningOutcomes={learningOutcomes}
                projectId={item.projectId}
                userId={item.userId}
              />
            )
          })}
        </Row>
      </div>



    )
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect((props) => {
    return [
      'projects', 'users', 'atl_category', 'learningOutcomes'
    ]
  }),
  connect(
    state => {
      const users = state.firebase.data.users
      const projects = state.firebase.data.projects
      let teacherSchoolId = state.firebase && state.firebase.profile.profile.school.id
      const selectedUsers = users && Object.entries(users)
        .filter(inv => inv[1].profile.school && inv[1].profile.school.id === teacherSchoolId)
        .map(inv => inv[0])

      let filteredData = {};
      projects && Object.entries(projects).filter(item => selectedUsers.indexOf(item[0]) >= 0).forEach(item => { filteredData[item[0]] = item[1] });


      return {
        users,
        projects: filteredData,
        projectFilter: state.projectFilter,
        atl_category: state.firebase.data.atl_category,
        learningOutcomes: state.firebase.data.learningOutcomes
      }
    }
  )
)

export default enhancer(IndividualProjects);



// WEBPACK FOOTER //
// ./src/containers/IndividualProjects/index.jsx